
//常量定义
export module JdConst{
    //调试模式
    export let isDebugMode = true;

    export let refreshUI = 'refreshUI';//刷新UI事件

    export let updateUI = '_updateUI';//刷新外部UI事件

    //提示信息
    export let ActionTip:{[k:number]:string} = {
        1:'',
        2:'operator_call',
        3:'operator_fold',
        4:'operator_check',
        5:'operator_rase',//加注
        6:'',
        7:'operator_all_in',
     } 

    export let pngStr:{[k:number]:string} = {
        2:'operator_small',
        3:'operator_big',
        5:'operator_fold',//弃牌
    }

    //通用的一些提示
    export let OpTips:{[k:number]:string} = {
        1:'dz_blind',
        4:'dz_totalpot',
        6:'dz_startnext',//九点倒计时
        7:'dz_betleaveroom',
        8:'dz_betfail',
        9:'dz_nextbetto',
        10:'dz_betto'
     } 
          //操作类型对应的气泡类型
    export let bubbleType:{[k:number]:string} = {
        // 1:'',
        // 2:'normal', //跟注
        // 3:'bad',//弃牌
        // 4:'normal',//让牌
        // 5:'strong',//加注
        // 6:'',
        // 7:'strong',//all-in
        // 8:'normal',//大盲注
        // 9:'normal',//小盲注
        1:'',
        2:'normal', 
        3:'bad',//
        4:'normal',//让牌
        5:'normal',//跟
        6:'strong',//加注
        7:'strong',//all-in
        8:'bad',//弃牌
        9:'normal',//小盲注
     } 

     //牌型显示
    export let PokerDes:{[k:number]:string} = {
        1:'pattern_1',//单牌//根据点数确定牌型
        2:'pattern_2',//同花
        3:'pattern_3',//顺子
        4:'pattern_4',//公仔牌
        5:'pattern_5',//同花顺
        6:'pattern_6',//三公
     } 

     export let JdDes:{[k:number]:string} = {
        1:'最小下注',
        2:'房间ID',
     } 

     //系统文字索引
     export let LocalPattern:{[k:number]:string} = {
        1:'dz_pattern_1',
        2:'dz_pattern_2',
        3:'dz_pattern_3',
        4:'dz_pattern_4',
        5:'dz_pattern_5',
        6:'dz_pattern_6',
        7:'dz_pattern_7',
        8:'dz_pattern_8',
        9:'dz_pattern_9',
        10:'dz_pattern_10',
     } 

     //下注状态
     export let CheckState:{[k:number]:string} = {
        8:'operator_big',
        9:'operator_small',
        2:'operator_call',
        5:'operator_rase',
        4:'operator_check',
     }

    //操作按钮类型
   export enum Operator{
       GiveUp = 1,//弃牌
       Fold_Check = 2,//跟或者让
       All_in = 3,
       Raise = 4,
   }

   //图片的显示类型
   export enum OperatorType{
        Image_Op = 0,//图片操作
        Anim_Op = 1,//动画操作
        Name_Op = 2,//名字操作
    }

    //玩家座位状态 控制状态显示的
    export enum SeatState{
        NoFight = 0,//
        fold = 8,//弃牌
        allin = 7,//all-in
        promote = 6,//加注
        follow = 5,//call
        pass = 4,//让牌
        bet = 3, //下了底注,相当于没有任何操作时的状态
        prepared = 2,//已经准备好参与牌局
        //0 就是为参与
    }

    export enum GameState{
        GameSettle = 0,//游戏结算
        Init = 1,//游戏初始化
    }


    //动画时间配置
    //下注筹码间隔
    export let checkInterval = 0.02
    //下注筹码移动时间
    export let checkMoveTime = 0.2;
    //归池筹码间隔
    export let guiChiInterval = 0.02;
    //归池筹码移动时间
    export let guiChiMoveTime = 0.2;
    //池中获取筹码间隔
    export let obtainInterval = 0.05;
    //池中获取筹码移动
    export let obtainMoveTime = 0.3;
    //手牌展示
    //手牌移动时间
    export let handsMoveTime = 0.25;
    //手牌放大的倍数
    export let handsScalTo = 1.3;
    //结束流程
    //亮牌总时间
    export let lightHandsTime = 0.6;
    //比牌结束时 vector显示时间
    export let vectorShowTime = 1.3;
    //归池完刷新玩家存留时间
    export let rounOverRefresh = 0.3;

}
